import React, {useState} from 'react';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import {get,keyBy,uniqBy} from 'lodash-es';
import Tabela from './Tabela';


export default function Funcionarios (props) {
  let { empresa } = props;
  let empresaId = empresa.value;
  const [ dptoSel, setDptoSel ] = useState("");
  const [ funcFilter, setFuncFilter ] = useState("");
  let funcionarios, dptos, dptosById;
  let funcionariosAExibir;
  const f = useFetchData(`${proto}://${url}/pessoal/empregados/${empresaId}/lista`)
  const d = useFetchData(`${proto}://${url}/pessoal/dpto/${empresaId}`)
  if (get(f,"isFinished") && get(d,"isFinished")) {
    funcionarios = get(f,"data",[]);
    funcionariosAExibir = funcionarios;
    let dptosEmUso = uniqBy(funcionarios, 'DptoID').map(el=>el.DptoID)
    dptos = get(d,"data",[]);
    dptos = dptos.filter(d => dptosEmUso.includes(d.Codigo))
    dptosById = keyBy(dptos, "Codigo")
    if (dptoSel) {
      funcionariosAExibir = funcionarios.filter(f => f.DptoID === dptoSel)
    }
    if (funcFilter) {
      let regex = new RegExp(funcFilter, 'gi')
      funcionariosAExibir = funcionarios.filter(f => f.Nome.search(regex) >= 0)
    }
  }
  if (get(f,"isLoading") || get(d,"isLoading")) return <div style={{marginTop: '80px', textAlign: 'center'}}>Carregando dados...</div>
  if (get(f,"error") || get(d,"error")) return <div>Erro ao carregar dados!</div>
  if (!funcionarios || !dptos || !dptosById) return <div>Aguarde...</div>
  return (
    <div style={{display: 'flex', justifyContent: 'center' }}>
      <Tabela
        empresaId={empresaId}
        qtde={[ funcionarios.length, funcionariosAExibir.length]}
        funcionarios={funcionariosAExibir}
        dptos={dptos}
        dptosById={dptosById}
        dptoSel={dptoSel}
        setDptoSel={setDptoSel}
        funcFilter={funcFilter}
        setFuncFilter={setFuncFilter}
      />
    </div>
  )
}
